/* eslint-disable import/prefer-default-export */

export const TYPES = {
  REGISTRATION_REQUEST: 'REGISTRATION_REQUEST',
  HIDE_POPUP: 'HIDE_POPUP',
  LOADED: 'LOADED',
  CLOSE: 'CLOSE',
  AUTHENTICATED: 'AUTHENTICATED'
};

let popup;

// duplicated in /server/pages/template
export const canSendNewFormat = () =>
  typeof window !== 'undefined' && window.location.search.includes('widget_sdk_version');

export function sendToParent(event, payload) {
  const windowParent = window.parent;
  if (windowParent && windowParent !== window) {
    if (canSendNewFormat()) {
      const data = {
        ...payload,
        type: event
      };
      windowParent.postMessage(data, '*');
    } else {
      windowParent.postMessage(event, '*');
    }
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('message', e => {
    if (e.data.type === TYPES.AUTHENTICATED) {
      sendToParent(TYPES.AUTHENTICATED, e.data);
      popup.close();
    }
  });
}

export function setPopupWindow(win) {
  popup = win;
}



// WEBPACK FOOTER //
// ../common/events.js